<!-- youtube-mobile-04 preview — YouTube home feed ad (in-feed video) -->
<app-mobile-frame>
  <app-youtube-mobile-navbar frameTop></app-youtube-mobile-navbar>

  <!-- START: Feed -->
  <div class="yt-m-feed">
    <!-- START: Organic card above the ad -->
    <div class="yt-m-card yt-f-filler">
      <img
        class="yt-f-filler-image"
        src="/assets/images/youtube-placeholder-video.png"
        alt=""
      />
      <div class="yt-f-filler-meta d-flex flex-row gap-2">
        <span class="yt-m-circle placeholder"></span>
        <div class="yt-f-filler-bars d-flex flex-column gap-2">
          <span class="yt-m-bar yt-f-bar-long placeholder"></span>
          <span class="yt-m-bar yt-f-bar-short placeholder"></span>
        </div>
      </div>
    </div>
    <!-- END: Organic card -->

    <!-- START: Real ad -->
    <div class="yt-m-card">
      <div class="yt-m-creative">
        <img
          *ngIf="thumbnailUrl; else noCreative"
          class="yt-m-creative-video"
          [src]="thumbnailUrl"
          alt=""
        />

        <ng-template #noCreative>
          <div class="yt-m-creative-video creative-missing">
            <ng-container *ngIf="isResolving; else askForVideo">
              Reading video formats&hellip;
            </ng-container>
            <ng-template #askForVideo>
              Add a {{ format }} video to see this preview
            </ng-template>
          </div>
        </ng-template>

        <!-- Only drawn over a creative — it is unreadable on the empty slot. -->
        <span class="yt-m-countdown" *ngIf="thumbnailUrl">00:08</span>
      </div>

      <div class="yt-m-info d-flex flex-row gap-2">
        <img
          class="yt-m-avatar"
          src="assets/images/valamar_logo_80x80.jpg"
          alt=""
        />
        <div class="yt-m-info-text">
          <h4 class="yt-m-title yt-f-title">{{ headline }}</h4>
          <div class="yt-m-desc">
            {{ data.descriptions[0] || "Your description appears here" }}
          </div>
          <div class="yt-m-meta"><strong>Sponsored</strong> &middot; Valamar</div>
        </div>
        <i class="bi bi-three-dots-vertical yt-m-more"></i>
      </div>

      <!-- START: Actions. "Watch" is YouTube's own, the dark pill is the ad's. -->
      <div class="yt-f-actions d-flex flex-row gap-2">
        <span class="yt-f-action yt-f-watch">Watch</span>
        <a
          class="yt-f-action yt-f-cta"
          [href]="data.url"
          target="_blank"
          rel="noopener noreferrer"
          >{{ data.ctaText || "Your call to action" }}</a
        >
      </div>
      <!-- END: Actions -->
    </div>
    <!-- END: Real ad -->

    <div class="yt-f-gap"></div>
  </div>
  <!-- END: Feed -->

  <app-youtube-mobile-bottom-nav frameBottom></app-youtube-mobile-bottom-nav>
</app-mobile-frame>
